import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from 'tms-lib';
import { MagentoCustomer } from '../../models';
import { TmsWebBaseService } from '../base/tms-web-base.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerMagentoService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('CustomerMagento', httpService);
  }

  getCustomer(id: number): Observable<MagentoCustomer> {
    return this.httpService.get<MagentoCustomer>(`${this.apiUrl}/GetCustomer/${id}`);
  }

  getCustomers(): Observable<MagentoCustomer[]> {
    return this.httpService.get<MagentoCustomer[]>(`${this.apiUrl}/GetCustomers`);
  }
}
